// /w/:wid/store → the Store of the city you are in (remembered), or of your first city in the world.
import { Navigate, useParams } from "react-router-dom";
import { useSession } from "@/state/session";
import { presenceVillageId, presenceVillages, useInit } from "@/state/queries";
import { Page } from "@/app/Page";
import { Card, Empty, Skeleton } from "@/kit/primitives";

export function StoreRedirect() {
  const { wid: widP } = useParams();
  const wid = Number(widP);
  const vid = useSession((s) => s.vid);
  const init = useInit();
  if (vid) return <Navigate to={`/w/${wid}/city/${vid}/store`} replace />;
  const first = presenceVillages(init.data?.world, wid).map(presenceVillageId).find((x): x is number => !!x);
  if (first) return <Navigate to={`/w/${wid}/city/${first}/store`} replace />;
  return (
    <Page header={{ kind: "title", title: "STORE", subtitle: "Gold and items" }}>
      {init.isLoading ? <Skeleton h={200} /> : <Card><Empty>Enter a city first — the Store buys for one city at a time.</Empty></Card>}
    </Page>
  );
}
